<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Stat from "../../components/widgets/stat";
import Multiselect from 'vue-multiselect';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Stat, Multiselect },
    data() {
        return {
            title: "Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/web/configuracion/laborantes"
                },
            ],
            usuarios:[],
            users:[],
            ordenCampo: 'promedio',
            ordenPromedio: 'desc',
            editing: false,
            dato:{
                coordinador:''
            }
        };
    },
    computed: {
        usuariosOrdenados() {
            return [...this.usuarios].sort((a, b) => {
                let valA, valB;
                if (this.ordenCampo === 'promedio') {
                    valA = parseFloat(this.prom_general(a)) || 0;
                    valB = parseFloat(this.prom_general(b)) || 0;
                } else if (this.ordenCampo === 'nombre') {
                    valA = a.name.toLowerCase();
                    valB = b.name.toLowerCase();
                }
                if (valA < valB) return this.ordenPromedio === 'asc' ? -1 : 1;
                if (valA > valB) return this.ordenPromedio === 'asc' ? 1 : -1;
                return 0;
            });
        }
    },
    mounted() {
    },
    methods: {
        msg(tipo,titulo){
            Swal.fire({
                icon: tipo,
                title: titulo,
                showConfirmButton: false,
                timer: 5000
            });
        },
        ver_mas(usuario){
            this.editing = false;
            usuario.boton = usuario.boton === 'Ver más' ? 'Ver menos' : 'Ver más';
        },
        showModal(us,ev){
            this.dato = {
                laborante: us.name,
                id: us.id,
                p1: ev.p1,
                r1: ev.r1,
                p2: ev.p2,
                r2: ev.r2,
                p3: ev.p3,
                r3: ev.r3,
                p4: ev.p4,
                r4: ev.r4
            };
            this.$refs['modal-evaluar'].show();
        },
        prom_general(item){
            let suma = 0;
            let total =0;
            item.evaluaciones.forEach(element => {
                if (element.prom!=null) {
                    suma = suma+ parseFloat(element.prom);
                    total = total +1;
                }
            });
            return total ? (suma / total).toFixed(2) : '0.00';
        },
        resetDato() {
            this.dato = { coordinador: '' };
        },
        filtrar_coordinador(item){
            let user = this.users.find(us=>us.id==item)
            return user.name
        },
        evaluacionesAgrupadas(evaluaciones) {
            // Filtramos solo las evaluaciones con promedio válido
            const filtradas = evaluaciones.filter(ev => ev.prom != null && ev.prom !== '');

            // Agrupamos por mes_ano
            const grupos = {};
            filtradas.forEach(ev => {
                if (!grupos[ev.mes_ano]) {
                    grupos[ev.mes_ano] = [];
                }
                grupos[ev.mes_ano].push(parseFloat(ev.prom));
            });

            // Calculamos promedio por mes
            const promedios = Object.keys(grupos).map(mes => {
                const valores = grupos[mes];
                const promedioMes = (valores.reduce((a, b) => a + b, 0) / valores.length).toFixed(2);
                return {
                    mes_ano: mes,
                    prom: promedioMes
                };
            });

            // Ordenamos por fecha (opcional, si tus meses están tipo "Octubre 2025")
            return promedios.sort((a, b) => new Date(b.mes_ano) - new Date(a.mes_ano));
        }

    },
    created(){
        axios.get('/api/get_todas_evaluaciones_laborantes').then(res=>{
            if(this.user.rol=='SuperAdmin' || this.user.rol=='Admin'){
                this.usuarios = res.data.laborantes.map(u => ({
                ...u,
                boton: 'Ver más'
                }));
            }else if(this.user.rol=='Supervisor'){
                this.usuarios = res.data.laborantes
                .map(u => ({
                    ...u,
                    boton: 'Ver más'
                }));
            }else if (this.user.rol=='Coordinador') {
                this.usuarios = res.data.laborantes
                .map(u => ({
                    ...u,
                    boton: 'Ver más'
                }))
                .filter(u => 
                    u.evaluaciones.some(ev => ev.resp_id == this.user.id)
                );
            }
        });
        axios.get('/api/get_bancos').then(response => {
            this.bancos = response.data.bancos;
        });
        axios.get('/api/get_usuarios').then(res=>{
            this.users=res.data.usuarios;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-star-half font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Evaluaciones Laborantes</h5>
                            <small class="text-white" style="opacity:.8;">Gestiona las evaluaciones de laborantes</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 20px;">#</th>
                                        <th style="width: 400px;">
                                            Nombre
                                            <b-button
                                                size="sm"
                                                variant="link"
                                                @click="
                                                ordenCampo === 'nombre'
                                                    ? (ordenPromedio = ordenPromedio === 'asc' ? 'desc' : 'asc')
                                                    : (ordenCampo = 'nombre', ordenPromedio = 'asc')
                                                "
                                            >
                                                <i
                                                v-if="ordenCampo === 'nombre'"
                                                :class="ordenPromedio === 'asc' ? 'font-siza-14 bx bx-sort-up' : 'font-siza-14 bx bx-sort-down'"
                                                ></i>
                                                <i v-else class="font-siza-14 bx bx-sort"></i>
                                            </b-button>
                                        </th>
                                        <th style="width: 150px;">Rut</th>
                                        <th style="width: 200px;">
                                            Promedio General
                                            <b-button
                                                size="sm"
                                                variant="link"
                                                @click="
                                                ordenCampo === 'promedio'
                                                    ? (ordenPromedio = ordenPromedio === 'asc' ? 'desc' : 'asc')
                                                    : (ordenCampo = 'promedio', ordenPromedio = 'desc')
                                                "
                                            >
                                                <i
                                                v-if="ordenCampo === 'promedio'"
                                                :class="ordenPromedio === 'asc' ? 'font-siza-14 bx bx-sort-up' : 'font-siza-14 bx bx-sort-down'"
                                                ></i>
                                                <i v-else class="font-siza-14 bx bx-sort"></i>
                                            </b-button>
                                        </th>
                                        <th class="text-right">Detalle</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="table-responsive" v-for="(usuario,index) in usuariosOrdenados" :key="usuario.id">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <th style="width: 20px;">{{ index+1 }}</th>
                                        <td style="width: 400px;">{{usuario.name}}</td>
                                        <td style="width: 150px;">{{usuario.rut}}</td>
                                        <td style="width: 200px;">
                                            <p class="text-center p-0 m-0 mr-3">
                                                <span
                                                    v-for="i in 5"
                                                    :key="i"
                                                    :class="prom_general(usuario) >= i ? 'bx bxs-star text-warning ml-1' : 'bx bxs-star ml-1'"
                                                ></span>
                                                <span class="ml-3">{{ prom_general(usuario) }}</span>
                                            </p>
                                        </td>
                                        <td class="text-right">
                                            <b-button v-b-toggle="'accordion-'+usuario.id" variant="primary" @click="ver_mas(usuario)">
                                                {{usuario.boton}}
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <b-collapse :id="'accordion-'+usuario.id" accordion="my-accordion" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-12" >
                                        <div class="card mt-3 shadow-sm border-light">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="offset-md-2 col-md-8">
                                                        <div class="table-responsive">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width: 20px;">#</th>
                                                                        <th style="width: 400px;">Mes</th>
                                                                        <!-- <th style="width: 400px;">Evaluado por</th> -->
                                                                        <th style="width: 150px;">Promedio</th>
                                                                        <th class="text-right">Detalle</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(ev,index2) in evaluacionesAgrupadas(usuario.evaluaciones)" :key="index2">
                                                                        <th style="width: 20px;">{{ index2+1 }}</th>
                                                                        <td style="width: 400px;">{{ev.mes_ano}}</td>
                                                                        <!-- <td style="width: 400px;">{{filtrar_coordinador(ev.resp_id)}}</td> -->
                                                                        <td style="width: 150px;">{{ev.prom}}</td>
                                                                        <td class="text-right">
                                                                            <b-button variant="primary" @click="showModal(usuario,ev)">
                                                                                Ver resultados
                                                                            </b-button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                    <b-modal ref="modal-evaluar" size="lg" :title="'Evaluar a '+this.dato.laborante" hide-footer @hidden="resetDato">
                        <div class="row" v-for="(pregunta, idx) in [
                            { label: '¿Es responsable en el cumplimiento de horarios y actividades agendadas?', model: 'r1', titulo: 'Preparación' },
                            { label: '¿Su presentación personal es acorde con el estándar institucional y a la actividad realizada?', model: 'r2', titulo: 'Presentación Personal' },
                            { label: '¿Maneja información relevante de la Universidad, Oferta Académica, Postulación, Becas, entre otros,  para entregar a los estudiantes cuando se le solicita?', model: 'r3', titulo: 'Contenido' },
                            { label: '¿Se desenvuelve en la actividad de manera empática con los alumnos, generando espacios de interacción y resolución de dudas?', model: 'r4', titulo: 'Habilidades' }
                            ]" :key="idx">
                            <div class="col-md-12 mb-3">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <label>{{ pregunta.titulo }}</label>
                                    <b-form-group :label="pregunta.label" v-slot="{ ariaDescribedby }">
                                        <div class="row mt-3 text-center">
                                            <div class="offset-md-1 col-md-3 text-right">
                                                <p class="mt-2">En desacuerdo</p>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-radio-group
                                                :id="'btn-radio-' + pregunta.model"
                                                v-model="dato[pregunta.model]"
                                                :aria-describedby="ariaDescribedby"
                                                :name="'radio-' + pregunta.model"
                                                buttons
                                                button-variant="warning"
                                                >
                                                    <b-form-radio v-for="i in 5" :key="i" :value="String(i)">{{ i }}</b-form-radio>
                                                </b-form-radio-group>
                                            </div>
                                            <div class="col-md-3 text-left">
                                                <p class="mt-2">Muy de acuerdo</p>
                                            </div>
                                        </div>
                                    </b-form-group>
                                </b-card>
                            </div>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </Layout>
</template>